import { useEffect, useState } from 'react';

import api from '@/services/api';

interface FeedbackCategory {
  category: string;
  label: string;
  icon: string;
}

const FALLBACK_CATEGORIES: FeedbackCategory[] = [
  { category: 'MICROPHONE', label: 'Le micro ne fonctionne pas', icon: 'Mic' },
  { category: 'CAMERA', label: 'La caméra ne fonctionne pas', icon: 'Camera' },
  { category: 'SOUND_OUTPUT', label: 'Son faible ou absent', icon: 'Volume2' },
  { category: 'TOUCHSCREEN', label: "L'écran tactile répond mal", icon: 'Hand' },
  { category: 'APP_BLOCKED', label: "L'application est bloquée", icon: 'Octagon' },
  { category: 'CONNECTIVITY', label: 'Problème de connexion', icon: 'Wifi' },
  { category: 'COMFORT', label: 'Confort (siège, chaleur…)', icon: 'Thermometer' },
  { category: 'CLEANLINESS', label: 'Propreté de la cabine', icon: 'Sparkles' },
  { category: 'OTHER', label: 'Autre problème', icon: 'MoreHorizontal' },
];

export function useFeedbackCategories() {
  const [categories, setCategories] = useState<FeedbackCategory[]>(FALLBACK_CATEGORIES);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function fetchCategories() {
      setLoading(true);
      try {
        const data = await api.get<FeedbackCategory[]>('/booth-feedback/categories');
        if (!cancelled && Array.isArray(data) && data.length > 0) {
          setCategories(data);
        }
      } catch {
        // Keep fallback categories
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchCategories();

    return () => {
      cancelled = true;
    };
  }, []);

  return { categories, loading };
}
